import { Settings as SettingsIcon } from 'lucide-react'

export default function Settings() {
  return (
    <div className="p-8">
      <h1 className="mb-8 text-2xl font-bold text-stone-900">Settings</h1>
      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-stone-300 py-16">
        <SettingsIcon className="mb-4 h-12 w-12 text-stone-300" />
        <h2 className="mb-1 text-lg font-semibold text-stone-700">
          Coming Soon
        </h2>
        <p className="text-sm text-stone-500">
          Creator settings and preferences will be available here.
        </p>
      </div>
    </div>
  )
}
